<template>
  <section class="carousel">
    <div v-if="bannerImages">
      <VueSlickCarousel 
        :arrows="true"
        :fade="true"
        :autoplaySpeed="7000"
        :speed="800"
        :autoplay="true"
        lazyLoad="ondemand"
      >
        <div v-for="(i, index) in bannerImages" :key="index">
          <img alt="" :src="i.url_image">
        </div>
      </VueSlickCarousel>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import axios from "axios";

export default {
  data() {
    return {
      isSolar: true,
      bannerImages: null,
    };
  },
  components: {
    VueSlickCarousel,
  },

  beforeMount() {
    let solar = JSON.parse(localStorage.getItem("isSaleSolar"));
    this.isSolar = solar;

    let canal = JSON.parse(localStorage.getItem("saleChannel"));
    // Busca os banners pelo canal
    axios.get(`https://www.leverosintegra.com.br/map/Api/CarouselLVI?saleChannel=${canal}`)
    .then(res => {
      this.bannerImages = res.data;
    }).catch(err => {
      console.log(err)
    })
  },
};
</script>

<style lang="scss">
.carousel {
  max-width: 100%;
  padding-top: 30px;

  .slick-prev {
    left: 40px;
    z-index: 1;

    &:before {
      color: var(--customDarkGreen);
      font-size: 1.563rem;

      @media (min-width: 441px) {
        font-size: 2.813rem;
      }
    }
  }

  .slick-next {
    right: 40px;

    &:before {
      color: var(--customDarkGreen);
      font-size: 1.563rem;

      @media (min-width: 441px) {
        font-size: 2.813rem;
      }
    }
  }

  .slick-dots li button:before {
    font-size: 0.938rem;
    color: var(--customDarkGreen);
  }

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
}
</style>